import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';

import Button from '../../statefull/Button';
import Heading from '../Heading';
import IconCard from '../IconCard';

import './index.scss';

const { REACT_APP_BME_URL } = process.env;

const openNavBar = () => {
  let _submenu = document.getElementsByClassName('sub-menu')[0];

  if (_submenu.classList.contains('hovered')) {
    document.getElementsByClassName('sub-menu')[0].classList.remove('hovered');
  } else {
    document.getElementsByClassName('sub-menu')[0].classList.add('hovered');
  }
};

const HeaderMenu = ({ menuItems, loggedIn = false, onChange }) => {
  const [hasHover, setHasOver] = useState(false);
  const [slug, setSlug] = useState('turnkey');

  const mouseLeaveHandler = useCallback(() => {
    setHasOver(false);
    setSlug('turnkey');
  }, []);

  return (
    <div className="header-navigation-panel">
      {
        loggedIn
          ? <div className="btn-wrapper logged-in-btn-wrapper">
            <a target="_blank" href={REACT_APP_BME_URL}>
              <Button color="primary" content='Go To Console' filled={true}/>
            </a>
          </div>
          : <>
            <nav className="main-menu">
              <ul className="main-menu-list">
                {
                  menuItems.map(item =>
                    <li className={`main-menu-li ${hasHover ? 'open-menu-web' : ''}`} key={item.name} onClick={onChange}>
                      {item.path
                        ? <Link to={'/' + item.path} className="text-capitalize">{item.name}</Link>
                        : <span className="text-capitalize"
                                onMouseEnter={() => setHasOver(true)}
                                onMouseLeave={mouseLeaveHandler}
                                onClick={openNavBar}>
                          <a href="/solutions#turnkey">{item.name}</a>
                        </span>
                      }
                      {item.subMenu &&
                      <div className="solutions-content-wrapper">
                        <div className="sub-menu"
                             onMouseLeave={mouseLeaveHandler}
                             onMouseEnter={() => setHasOver(true)}>
                          {
                            item.subMenu?.map(subItem =>
                              <div className="sub-menu-items" key={subItem.name}>
                                <input id={subItem.slug + 'headerMenuItem'} type="radio" name="subItem"
                                       value={subItem.slug}
                                       onChange={() => setSlug(subItem.slug)}
                                       checked={subItem.slug === slug}
                                       defaultChecked={subItem.slug === 'turnkey'}
                                       className="hidden"/>
                                <label htmlFor={subItem.slug + 'headerMenuItem'}
                                       className="text-capitalize">{subItem.name}</label>
                                <div className="nested-menu">
                                  <a className="nested-menu-title" onClick={() => setHasOver(false)} href={'/' + subItem.path}>{subItem.name}<i
                                    className="back-icon"></i> </a>
                                  {
                                    subItem.nestedSubMenu?.products &&
                                    <>
                                      <Heading size="xxs" content="Products"/>
                                      <div className="nested-menu-inner">
                                        {
                                          subItem.nestedSubMenu?.products.map(nestedSubItem =>
                                            <Link to={nestedSubItem.path} onClick={() => setHasOver(false)}>
                                              <div className="nested-menu-i-row" key={nestedSubItem.name}>
                                                <IconCard size="small" icon={nestedSubItem.icon}/>
                                                <div className="nested-menu-i-info">
                                                  <Link to={nestedSubItem.path}
                                                        className="text-capitalize">{nestedSubItem.name}</Link>
                                                  <p className="nested-menu-i-info-txt">{nestedSubItem.description}</p>
                                                </div>
                                              </div>
                                            </Link>
                                          )
                                        }
                                      </div>
                                    </>
                                  }
                                  {
                                    subItem.nestedSubMenu?.tools &&
                                    <>
                                      <Heading size="xxs" content="Tools"/>
                                      <div className="nested-menu-inner">
                                        {
                                          subItem.nestedSubMenu?.tools.map(nestedSubItem =>
                                            <Link to={nestedSubItem.path}  onClick={() => setHasOver(false)}>
                                              <div className="nested-menu-i-row" key={nestedSubItem.name}>
                                                <IconCard size="small" icon={nestedSubItem.icon}/>
                                                <div className="nested-menu-i-info">
                                                  <Link to={nestedSubItem.path}
                                                        className="text-capitalize">{nestedSubItem.name}</Link>
                                                  <p className="nested-menu-i-info-txt">{nestedSubItem.description}</p>
                                                </div>
                                              </div>
                                            </Link>
                                          )
                                        }
                                      </div>
                                    </>
                                  }
                                  {
                                    subItem.nestedSubMenu?.payments &&
                                    <>
                                      <Heading size="xxs" content="Payments"/>
                                      <div className="nested-menu-inner">
                                        {
                                          subItem.nestedSubMenu?.payments.map(nestedSubItem =>
                                            <Link to={nestedSubItem.path}  onClick={() => setHasOver(false)}>
                                              <div className="nested-menu-i-row" key={nestedSubItem.name}>
                                                <IconCard size="small" icon={nestedSubItem.icon}/>
                                                <div className="nested-menu-i-info">
                                                  <Link to={nestedSubItem.path}
                                                        className="text-capitalize">{nestedSubItem.name}</Link>
                                                  <p className="nested-menu-i-info-txt">{nestedSubItem.description}</p>
                                                </div>
                                              </div>
                                            </Link>
                                          )
                                        }
                                      </div>
                                    </>
                                  }
                                </div>
                              </div>
                            )
                          }
                        </div>
                      </div>
                      }
                    </li>
                  )
                }
              </ul>
            </nav>
            <div className="sign-block">
              <div className="btn-wrapper">
                <Link to="/become-partner">
                  <Button onClick={onChange} className="text-uppercase sign-in-btn" color="primary"
                          content={'Become a partner'}
                          stroked={true}/>
                </Link>
              </div>
              <div className="btn-wrapper">
                <a target="_blank" href={REACT_APP_BME_URL}>
                  <Button onClick={onChange} className="text-uppercase sign-in-btn" color="primary"
                          content={'Go to Console'}
                          filled={true}/>
                </a>
              </div>
            </div>
          </>
      }
    </div>
  )
}

export default HeaderMenu;
